// locationsApi.ts
import api from './api';
import { Location, CreateLocationRequest, UpdateLocationRequest } from '../types/locations';

export const locationsApi = {
  getAllLocations: async (): Promise<Location[]> => {
    const response = await api.get('/locations');
    return response.data;
  },

  getLocation: async (id: number): Promise<Location> => {
    const response = await api.get(`/locations/${id}`);
    return response.data;
  },

  createLocation: async (request: CreateLocationRequest): Promise<Location> => {
    const response = await api.post('/locations', request);
    return response.data;
  },

  updateLocation: async (id: number, request: UpdateLocationRequest): Promise<Location> => {
    const response = await api.put(`/locations/${id}`, request);
    return response.data;
  },

  deleteLocation: async (id: number): Promise<void> => {
    await api.delete(`/locations/${id}`);
  }
};